import { CartStateGetSet } from "@/cart/types";
import { isRefKit } from "@/utils/ShopifyHelpers";
import GRAPHQL_CLIENT from "@/graphql/client";
import { Cart, CartLineInput } from "@/graphql/generated";
import { MATIC_REFKIT_VARIANT_ID, MATIC_VARIANT_ID } from "@/consts/shopify";
import mixpanel from "mixpanel-browser";

export const addItem = ({ get, set }: CartStateGetSet) => {
  return async (variantId: string) => {
    let lines: CartLineInput[] = [{
      merchandiseId: variantId,
      quantity: 1,
      attributes: [],
    }];
    if (variantId == MATIC_REFKIT_VARIANT_ID) {
      return;
    }


    const isMaticVar = variantId == MATIC_VARIANT_ID;

    let cart: Cart | undefined;

    const { cartId } = get();
    cart = await addToOrCreateCart(lines, cartId);
    
    const isRefkitInCart = cart?.lines.edges.some(({ node }) => isRefKit(node));
    const referralCodes = cart?.discountCodes?.filter(({ code}) => code.toUpperCase().startsWith('FRIEND-'));

    if (isMaticVar && cart && !isRefkitInCart && referralCodes?.length > 0) {
      cart = await addToOrCreateCart([{
        merchandiseId: MATIC_REFKIT_VARIANT_ID,
        quantity: 1,
        attributes: [],
      }], cart.id);

      mixpanel.track("add_item", { variantId, cartId: cart?.id });

      const newReferralCodes = cart?.discountCodes?.filter(({ code, applicable }) => code.toUpperCase().startsWith('FRIEND-') && applicable);
      const refKitLine = cart?.lines.edges.find(({ node }) => isRefKit(node));

      if (newReferralCodes?.length == 0 || refKitLine?.node.cost.totalAmount.amount != 0) {
        const { cartLinesRemove } = await GRAPHQL_CLIENT.RemoveFromCart({
          cartId: cart.id,
          lineIds: [cart?.lines.edges.find(({ node }) => isRefKit(node))?.node.id],
        });
        cart = cartLinesRemove?.cart as Cart;
      }
    }

    

    if (!cart) throw new Error("addItem: Adding line to cart failed");

    set({ cartId: cart.id, cart });
  };
};


const addToOrCreateCart = async (lines: CartLineInput[], cartId: string) => {
  if (cartId) {
    const { cartLinesAdd } = await GRAPHQL_CLIENT.AddToCart({
      cartId,
      lines,
    });
    return cartLinesAdd?.cart as Cart;
  } else {
    mixpanel.track("create_cart", { lines, cartId });
    const { cartCreate } = await GRAPHQL_CLIENT.CartCreate({
      input: { lines },
    });
    return cartCreate?.cart as Cart;
  }
}